import { FC } from 'react';
import { Redirect } from 'react-router';

import useAuthenticatedAction from 'common/hooks/useAuthenticatedAction';
import { Scope } from 'common/hooks/useAuthenticatedAction/types';
import Text from 'components/_core/Text';
import Loader from 'components/Loader';
import PasscodeInput from 'components/PasscodeInput';

import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import useCreateAccountClosure from './hooks/useCreateAccountClosure';
import locales from './locales';
import { PasscodeWrapper } from './styles';

const ConfirmationCode: FC = () => {
  const {
    canCloseAccount,
    createAccountClosure,
    loading: isLoadingAccountClosureCreation,
  } = useCreateAccountClosure();

  const { isLoading: isLoadingAuthenticatedAction, onPasscodeSubmit } =
    useAuthenticatedAction({
      onPasscodeSuccess: createAccountClosure,
      scope: Scope.HOLDER,
    });

  // if the user
  // - takes too long the session might have been purged
  // - tries to access the final url directly
  // making the reasons null. If so redirect to the start
  // of the account closure flow.
  //
  // TODO(kemi): add guard front and back to ensure that
  // the user isn't skipping the identity check.
  if (!canCloseAccount) {
    return <Redirect to="/company/account-closure" />;
  }

  const isLoading =
    isLoadingAuthenticatedAction || isLoadingAccountClosureCreation;

  return (
    <Wrapper>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Title>{locales.title}</Title>
          <Text size="sm">{locales.body}</Text>
          <PasscodeWrapper>
            <PasscodeInput hidden length={4} onSubmit={onPasscodeSubmit} />
          </PasscodeWrapper>
        </>
      )}
    </Wrapper>
  );
};

export default ConfirmationCode;
